/**
 * @Author: ZLZ
 * @Date: 2025-09-11 14:28:25
 * @LastEditors: ZLZ
 * @Description: 参数字段见/utils/index.js => getEnvironment方法返回值
 * @FilePath: \qs\src\stores\adhibition.js
 */
import { defineStore } from "pinia";
export const useAdhibitionStore = defineStore("adhibition", {
  state: () => ({
    environment: {
      isApp: false, // 是否是app环境
      isDesktop: false, // 是否是桌面环境
      isMobile: true, // 是否是移动端环境
      isWeChat: false, // 是否是微信环境
      isWeChatWork: false, // 是否是企业微信环境
      os: "ios", // 操作系统
      platform: "mobile_browser", // 平台
    },
  }),
  actions: {
    setEnvironment (info) {
      this.environment = {
        ...this.environment,
        ...info
      };
    }
  }
});
